<template>
  <div id="app">
    <nav class="navbar navbar-expand-md navbar-dark bg-dark mb-4">
      <a href class="navbar-brand" @click.prevent>EDIBLE HERBS</a>
      <div class="navbar-nav mr-auto">
        <div v-if="currentUser && showSuperAdminBoard" class="collapse navbar-collapse" id="navbarCollapse">
          <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <a class="nav-link dropdown-toggle" href="#" id="settingMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <font-awesome-icon icon="cog" />
                  Setting
                </a>
                <div class="dropdown-menu dropdownitemalign" aria-labelledby="settingMenu">
                  <router-link to="/users" class="dropdown-item"><font-awesome-icon icon="users" /> Users</router-link>
                  <div class="dropdown-divider"></div>
                  <router-link to="/products" class="dropdown-item"><font-awesome-icon icon="list" /> Products</router-link>
                  <div class="dropdown-divider"></div>
                  <router-link to="/countries" class="dropdown-item"><font-awesome-icon icon="list" /> Countries</router-link>
                  <div class="dropdown-divider"></div>
                  <router-link to="/states" class="dropdown-item"><font-awesome-icon icon="list" /> States</router-link>
                  <div class="dropdown-divider"></div>
                  <router-link to="/changeMemberPasswords" class="dropdown-item"><font-awesome-icon icon="list" /> Change Member Passwords</router-link>
                </div>
              </li>
          </ul>
        </div>
        <li v-if="showSuperAdminBoard || showAdminBoard || showAuditorBoard || showManagerBoard || showDataEntryBoard || showUserBoard" class="nav-item">
          <router-link to="/dashboard" class="nav-link"><font-awesome-icon icon="desktop" /> Dashboard</router-link>
        </li>
        <li v-if="showSuperAdminBoard || showAdminBoard || showAuditorBoard || showManagerBoard || showDataEntryBoard" class="nav-item">
          <router-link to="/members" class="nav-link"><font-awesome-icon icon="table" /> Members</router-link>
        </li>
        <li v-if="showSuperAdminBoard || showAdminBoard || showAuditorBoard || showManagerBoard || showDataEntryBoard" class="nav-item">
          <router-link to="/sales" class="nav-link"><font-awesome-icon icon="list" /> Sales</router-link>
        </li>
        <li v-if="showSuperAdminBoard" class="nav-item">
          <router-link to="/calculationboard" class="nav-link"><font-awesome-icon icon="desktop" /> Calculation Board</router-link>
        </li>
        <li v-if="showSuperAdminBoard" class="nav-item">
          <router-link to="/auditLogs" class="nav-link"><font-awesome-icon icon="list" /> Audit Logs</router-link>
        </li>
        <div v-if="currentUser && showSuperAdminBoard || showAdminBoard || showAuditorBoard || showManagerBoard" class="collapse navbar-collapse dropright" id="navbarCollapse">
          <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <a class="nav-link dropdown-toggle" href="#" id="reportsMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <font-awesome-icon icon="file-alt" />
                  Reports
                </a>
                <div class="dropdown-menu" aria-labelledby="reportsMenu">
                  <h6 class="dropdown-header">Members' Bonuses</h6>
                  <router-link to="/bonuses" class="dropdown-item"><font-awesome-icon icon="gifts" /> All Bonuses</router-link>
                  <router-link to="/filteredBonuses" class="dropdown-item"><font-awesome-icon icon="gift" /> Filtered Bonuses</router-link>
                  <div class="dropdown-divider"></div>
                  <router-link to="/activations" class="dropdown-item"><font-awesome-icon icon="check-circle" /> Activations</router-link>
                  <div class="dropdown-divider"></div>
                  <router-link to="/awards" class="dropdown-item"><font-awesome-icon icon="award" /> Awards</router-link>
                </div>
              </li>
          </ul>
        </div>
        <li v-if="showUserBoard" class="nav-item">
          <router-link to="/memberDownlines" class="nav-link"><font-awesome-icon icon="table" /> My Downlines</router-link>
        </li>
        <li v-if="showUserBoard" class="nav-item">
          <router-link to="/memberPurchases" class="nav-link"><font-awesome-icon icon="list" /> My Purchases</router-link>
        </li>
        <li v-if="showUserBoard" class="nav-item">
          <router-link to="/memberBonusReport" class="nav-link"><font-awesome-icon icon="list" /> My Bonus Report</router-link>
        </li>
        <!--<li v-if="showSuperAdminBoard" class="nav-item">
          <router-link to="/superadmin" class="nav-link">Dashboard</router-link>
        </li>
        <li v-if="showAdminBoard" class="nav-item">
          <router-link to="/admin" class="nav-link">Dashboard</router-link>
        </li>
        <li v-if="showAuditorBoard" class="nav-item">
          <router-link to="/aud" class="nav-link">Dashboard</router-link>
        </li>
        <li v-if="showManagerBoard" class="nav-item">
          <router-link to="/man" class="nav-link">Dashboard</router-link>
        </li>
        <li v-if="showDataEntryBoard" class="nav-item">
          <router-link to="/man" class="nav-link">Dashboard</router-link>
        </li>-->
        
      </div>

      <div v-if="!currentUser" class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link to="/login" class="nav-link">
            <font-awesome-icon icon="sign-in-alt" />Login
          </router-link>
        </li>
      </div>
      
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div v-if="currentUser" class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link dropdown-toggle" href="#" id="userMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <font-awesome-icon icon="user" />
                {{ currentUser.username }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userMenu">
                <router-link to="/profile" class="dropdown-item"><font-awesome-icon icon="edit" /> Edit Profile</router-link>
                <div class="dropdown-divider"></div>
                <router-link :to="{ path: '/changePassword/' + currentUser.id }" class="dropdown-item"><font-awesome-icon icon="pencil-alt" /> Change Password</router-link>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href @click.prevent="logOut">
                  <font-awesome-icon icon="sign-out-alt" /> LogOut
                </a>
              </div>
            </li>
        </ul>
        <!-- <li class="nav-item">
          <router-link to="/profile" class="nav-link">
            <font-awesome-icon icon="user" />
            {{ currentUser.username }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/changepassword" class="nav-link">
            <font-awesome-icon icon="edit" />
            Change Password
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" href @click.prevent="logOut">
            <font-awesome-icon icon="sign-out-alt" />LogOut
          </a>
        </li> -->
      </div>
    </nav>

    <div class="col-sm-12">
      <router-view />
    </div>
    <footer class="footer">
      <div class="col-sm-12">
        &copy; 2020 <a target="_blank" href="#" title="Matrix MLM">Edible Herbs Ltd</a>. All Rights Reserved. <span style="font-size: 8px;">Powered by Firmgrip Ltd.</span>
      </div>
    </footer> 
  </div>
</template>

<script>
export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showSuperAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_SUPERADMIN');
      }

      return false;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_ADMIN');
      }

      return false;
    },
    showAuditorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_AUDITOR');
      }

      return false;
    },
    showManagerBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_MANAGER');
      }

      return false;
    },
    showDataEntryBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_DATAENTRY');
      }

      return false;
    },
    showUserBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_USER');
      }

      return false;
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  }
};
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        min-height: 100vh !important;
        display: flex !important;
        flex-direction: column !important;
    }
    /*.justify-content-center .dropdown-menu {
        left: 50%;
        transform: translateX(-50%);
    }*/

    .nav-link.active, .nav-link:focus {
        background-color: green !important;
        color: #fff !important;
    }

    .dropdown-toggle.active {
        background-color: green;
    }

    .dropdown-toggle:active, .open .dropdown-toggle,.dropdown-toggle:focus {
        background-color: green !important;
        color: #fff !important;
    }

    .dropdown-menu {
        background-color: green !important;
        border-top: 1px solid white;
        border-right: 1px solid white;
        border-left: 1px solid white;
        border-bottom: 1px solid white;
    }   

    /*.dropdown-menu-center {
        right: auto;
        left: 100%;
        transform: translateX(100%);
        -webkit-transform: translate(100%, 0);
        -o-transform: translate(100%, 0);
        transform: translate(100%, 0);
    }*/

    .dropdownitemalign {
        left: 10%;
    }

    .dropdown-menu-left {
        right: auto;
        left: 50%;
        transform: translateX(50%);
        -webkit-transform: translate(50%, 0);
        -o-transform: translate(50%, 0);
        transform: translate(50%, 0);
    }

    .dropdown-item {
       color: #fff !important;
    }

    .dropdown-item:hover {
      background-color: green !important;
      color: #000 !important;
    }

    .dropdown-header {
      font-weight: bold !important;
      font-size: .97em !important;
      color: #000 !important;
    }

    .footer {
      display: flex;
      flex-direction: column;
      margin-top: 3em;
      height: 9em;
      padding: 4em 1em;
      background-color: #fd9644 !important;
      color: #000 !important;
    }

    .footer a {
      /*color: #d96b39;
      color: #0e7ac2;*/
      color: green !important;
    }

    .footer span {
      float: right;
      color: #000 !important;
    }

    .footer .icon {
      height: 23px;
      display: inline-block;
      margin-bottom: -6px;
    }

    .hr {
      border-bottom: 1px solid #dbdbdb;
      margin: 3em 0;
    }

    .footer p {
      font-size: 15px;
      color: #767676 !important;
    }

</style>